import {
  inWeiXin,
  inWxMp,
  inWxPc,
  inMQQ,
  inApp,
  inSubApp,
  inWZApp,
  inXSApp,
  inDKApp,
  inPC,
  inMobile,
  inIOS,
  inAndroid,
  inEnvDev,
  inEnvTest,
  inEnvPrd,
  inXSWeb,
  inWZWeb,
  inZFFWeb
} from '../../../utils/wz.v2'

export default {
  inEnvDev: () => inEnvDev(),
  inEnvPrd: () => inEnvPrd(),
  inEnvTest: () => inEnvTest(),
  
  inApp: () => inApp(),  
  inSubApp: () => inSubApp(),
  inSubIos: () => inSubApp('i'),
  inSubAndroid: () => inSubApp('a'),
  
  inDKApp: () => inDKApp(),
  inDKIos: () => inDKApp('i'),
  inDKAndroid: () => inDKApp('a'),
  
  inWZApp: () => inWZApp(),
  inWZIos: () => inWZApp('i'),
  inWZAndroid: () => inWZApp('a'),
  
  inXSApp: () => inXSApp(),
  inXSIos: () => inXSApp('i'),
  inXSAndroid: () => inXSApp('a'),
  
  inXSWeb: () => inXSWeb(),
  inWZWeb: () => inWZWeb(),
  inZFFWeb: () => inZFFWeb(),
  
  inAndroid: () => inAndroid(),
  inIOS: () => inIOS(),
  inWeiXin: () => inWeiXin(),
  inWxMp: () => inWxMp(),
  inWxPc: () => inWxPc(),
  inMQQ: () => inMQQ(),
  inPC: () => inPC(),
  inMobile: () => inMobile()
}
